import { useLocation } from 'react-router-dom';

export default function useBusinessNumber() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const businessNumber = searchParams.get('businessNumber');

  return {
    businessNumber,
  };
}
